<template>
  <div 
      class="wg-row" 
      style="flex-wrap:nowrap;align-items:center;justify-content:center;cursor:pointer;">
      <div
          v-for="(filter,index) in filters"
          :key="'filter-'+index"
          class="display-flex filter-button"
          @click="removeFilter(index)"
      >
        <img 
            class="com-anm22-app-img-fixed-height-s" 
            :src="$anm22.icons.getWorldIcon('deleteBlack')" 
            style="margin-right:10px;">
        <div class="com-anm22-app-text-m">{{ filter.name }}</div>
      </div>
  </div>
</template>

<script>
export default {
  props: {
     filters: {
      type: Array,
      default: () => []
    },
    eventName: String
  },
  data() {
    return {}
  },
  methods: {
    addFilter(filter) {
      this.filters.push({name: filter.name, fn: filter.fn});
      this.$emit('filtersUpdate', this.filters);
    },
    removeFilter(index) {
      this.filters.splice(index, 1);
      this.$emit('filtersUpdate', this.filters);
    },
    resetFilters() {
      this.filters = [];
    }
  },
  created() {
    // COOKIE ?
  },
  mounted() {
    this.$anm22.eventBus.$on(this.eventName, this.addFilter);
  },
  destroyed() {
    this.$anm22.eventBus.$off(this.eventName);
  }
}
</script>

<style lang="scss" scoped>
.filter-button {
  flex-wrap:nowrap;
  align-items:center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  background-color: #ddd;
  border-radius: 5px;
  padding: 10px;
  margin: 0 5px;
}
</style>
